let langKey = null;
export const setLangKey = lang => {
  if (lang) {
    langKey = lang.split('-')[0];
  }
};
export const resetLangKey = () => {
  langKey = null;
};
const getLangKey = () => {
  return langKey || 'en';
};
export default getLangKey;